import { defineComponent as a, computed as i } from "vue";
import u from "./td-longtail-vue-components266.js";
const l = /* @__PURE__ */ a({
  __name: "single-item-configurator",
  props: {
    bundleItem: { default: void 0 },
    isAccessible: { type: Boolean, default: !0 }
  },
  emits: ["select-variant"],
  setup(n) {
    const e = n, s = i(() => {
      if (!e.bundleItem?.variants) return [];
      const t = [];
      return Object.keys(e.bundleItem.variants).forEach((o) => {
        const r = e.bundleItem?.variants[o];
        r && t.push(r);
      }), t;
    });
    return { __sfc: !0, props: e, filteredVariants: s, VariantSelector: u };
  }
});
export {
  l as default
};
